import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../shared/my-constants';

//  import * as webapi from '../../assets/js/webproperty.js';
@Injectable()
export class MisService {
    city: any;
    hasCreateAccess = true;
    hasEditAccess = true;
    hasDeleteAccess = true;
    private headers = new Headers({'Content-Type': 'application/json'});
    private GetAppointmentList = webapi + 'mis/appointmentlist?';
    private GetRegistrationList = webapi + 'mis/registrationlist?';
    private GetVisitList = webapi + 'mis/visitlist?';
    private GetRadiologytestlist = webapi + 'mis/radiotestlist?';
    private GetBilllist = webapi + 'mis/billlist?';
    private GetCollectionsummery = webapi + 'mis/collectionsummery?';
    private GetPharmacybilllist = webapi + 'mis/getpharmacybilllist?';
    private GetPharmacyreturnlist = webapi + 'mis/getpharmacyreturnlist?';
    private GetLablist = webapi + 'mis/pathlogylist?';
    private GetServicebytariff = webapi + 'mis/getservicelistbytariff?';
    private getUnitNameByStaffIdURL = webapi + 'mis/getUnitByStaffId/?';

    constructor(private http: Http) {
    }

    getAppointmentList(search_query: any): Promise<any> {
        return this.http.post(this.GetAppointmentList, JSON.stringify(search_query), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRegistrationList(search_query: any): Promise<any> {
        return this.http.post(this.GetRegistrationList, JSON.stringify(search_query), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getVisitList(search_query: any): Promise<any> {
        return this.http.post(this.GetVisitList, JSON.stringify(search_query), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    //  getRadiologytestlist(currentPage: any, size: any, qString: any, sort: any, col: any,search_query:any): Promise<any> {
    //    // console.log(this.GetRadiologytestlist + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col + '&search_query='+search_query)
    //   // console.log(search_query);
    //    return this.http.get(this.GetRadiologytestlist + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col + '&search_query='+search_query)
    //      .toPromise()
    //      .then(response => response.json())
    //      .catch(this.handleError);
    //  }
    getRadiologytestlist(search_query: any): Promise<any> {
        return this.http.post(this.GetRadiologytestlist, JSON.stringify(search_query), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getBilllist(search_query: any): Promise<any> {
        return this.http.post(this.GetBilllist, JSON.stringify(search_query), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    //  getRadiologyperformancelist(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    //    return this.http.get(this.GetRadiologyperformancelist + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
    //      .toPromise()
    //      .then(response => response.json())
    //      .catch(this.handleError);
    //  }
    getCollectionsummery(search_query: any): Promise<any> {
        return this.http.post(this.GetCollectionsummery, JSON.stringify(search_query), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getPharmacybilllist(search_query: any): Promise<any> {
        return this.http.post(this.GetPharmacybilllist, JSON.stringify(search_query), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getPharmacyreturnlist(search_query: any): Promise<any> {
        return this.http.post(this.GetPharmacyreturnlist, JSON.stringify(search_query), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getLablist(search_query: any): Promise<any> {
        return this.http.post(this.GetLablist, JSON.stringify(search_query), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getServicebytariff(search_query: any): Promise<any> {
        return this.http.post(this.GetServicebytariff, JSON.stringify(search_query), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getUnitNameByStaffIdForMis(staffId: any): Promise<any> {
        return this.http.get(this.getUnitNameByStaffIdURL + 'staffId=' + staffId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/mis/mis.service.ts